export default __webpack_public_path__ + "static/media/phylactere_maman_FR.e7d28306.png";